import {
  Box,
  Button,
  Card,
  Chip,
  Divider,
  Paper,
  Typography,
} from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ActionOnCommandIcon from '../../../svg-icons/ActionOnCommandIcon';
import SAVOrderIcon from '../../../svg-icons/SAVOrderIcon';
import { getCurrencySymbol } from '../ActionPane/Orders/Retractions/FeesCalculations';

const SavOrderRecap = ({ savOrder, currency }) => {
  const navigate = useNavigate();
  const users = useSelector((state) => state.static.users);

  if (!savOrder) {
    return null;
  }

  const savDatasFromBO = savOrder?.savDatasFromBO;

  if (!savDatasFromBO) {
    return null;
  }

  const getAuthorName = () => {
    const user = users?.find(
      (user) => user.email === savOrder?.savDatasFromBO.created_by
    );
    return user
      ? `${user?.firstName} ${user?.lastName}`
      : savOrder?.savDatasFromBO?.created_by;
  };

  const nameToDisplay = getAuthorName();

  const handleNavigateToTicket = () => {
    navigate(
      `/project/${savOrder?.project?._id}/tickets/${savOrder?.savTicketId}/activities`
    );
  };

  return (
    <Paper
      elevation={16}
      key={savOrder?.reference}
      sx={{
        padding: 0,
        marginBottom: 1,
        boxShadow: 'none',
      }}
    >
      <Card
        elevation={5}
        sx={{
          display: 'flex',
          gap: 2,
          padding: 1,
          alignItems: 'center',
          justifyContent: 'space-evenly',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <ActionOnCommandIcon fontSize="large" />
            <Typography component={'span'} sx={{ fontSize: '0.9em' }}>
              Commande SAV
            </Typography>
            <Chip
              label={
                savOrder?.savDatasFromBO?.is_payable
                  ? `SAV Payant ${savOrder?.savDatasFromBO?.amount_ttc_net} ${getCurrencySymbol(currency)}`
                  : 'SAV Gratuit'
              }
              color={
                savOrder?.savDatasFromBO?.is_payable ? 'warning' : 'success'
              }
              variant="outlined"
            />
            <Chip
              label={savOrder?.paymentStatus?.name}
              color="info"
              variant="outlined"
            />
            <Typography component={'span'} sx={{ fontSize: '0.9em' }}>
              {nameToDisplay}
            </Typography>
            <Typography component={'span'} variant="caption">
              {new Date(savOrder?.savDatasFromBO?.created_at).toLocaleString(
                'fr-FR',
                {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                }
              )}
            </Typography>
          </Box>
          <Divider sx={{ mt: 1 }} />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
            <Typography sx={{ fontSize: '0.9em' }}>
              <strong>Liste des pièces / colis :</strong>
            </Typography>
            <Box
              sx={{ display: 'flex', flexDirection: 'column', gap: 1, pl: 2 }}
            >
              {savOrder?.lines?.map((line, index) => (
                <Box
                  key={`${line?.reference}-${index}`}
                  sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}
                >
                  <Typography sx={{ fontSize: '0.8em' }}>
                    {`${line?.quantity} x `}
                    <strong>{line?.reference}</strong>{' '}
                    {!!line?.title && line?.title}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
            <Typography sx={{ fontSize: '0.9em' }}>
              <strong>Préparateur</strong>:{' '}
              {savOrder?.sender || 'Non renseigné'}
            </Typography>
          </Box>
          {savOrder?.savTicketId && (
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, mt: 1 }}>
              <Button
                variant="contained"
                size="small"
                onClick={handleNavigateToTicket}
                sx={{
                  textTransform: 'none',
                  backgroundColor: '#10407B',
                  ':hover': {
                    backgroundColor: '#0b2d56',
                  },
                }}
              >
                Voir le ticket
              </Button>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <SAVOrderIcon fontSize="medium" />
            <Chip
              label={`Commande SAV ${savOrder?.status?.name}`}
              color={
                savOrder?.status?.name === 'delivered'
                  ? 'success'
                  : savOrder?.status?.name === 'error'
                    ? 'error'
                    : 'warning'
              }
              variant="outlined"
              size="small"
              sx={{ width: 'fit-content', borderRadius: '5px' }}
            />
          </Box>
          <Typography
            sx={{
              color: 'primary.main',
              fontWeight: 'bold',
            }}
          >
            {savOrder?.reference}
          </Typography>
        </Box>
      </Card>
    </Paper>
  );
};

export default SavOrderRecap;
